import { aiMinutesTemplateRepo } from "@/repositories/aiMinutesTemplateRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetAIMinutesTemplate = (
  tenantId: string,
  aiMinutesTemplateId: string
) => {
  return useObservable(
    () => aiMinutesTemplateRepo.get(tenantId, aiMinutesTemplateId),
    [tenantId, aiMinutesTemplateId]
  );
};

export const useAIMinutesTemplateList = (tenantId: string) => {
  return useObservable(() => aiMinutesTemplateRepo.list(tenantId), [tenantId]);
};
